import React, { useState, Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";
import Selector from "canvas-core-react/lib/Selector";
import useApi from "../../hooks/useApi";
import Modal from "../../utils/customModal";
import { loadingHtml } from "../../utils/functions";

import reporticon from "../../../../static/images/Reports.svg";
import { getReportTypes } from "../../../Redux/reducer/reports";
import {
  reportType,
  getReportData,
} from "../../../Redux/actions/reportActions";
import { getSessionInfo } from "../../../Redux/reducer/session";
import FiltersByReport from "./reportFilters";

const ReportsFilters = (props) => {
  const [modal, setModal] = useState({
    show: false,
    content: null,
    onClose: undefined,
  });

  const [report, setReport] = useState("");
  const [filters, setFilters] = useState([]);
  const [filterValue, setFilterValue] = useState({});
  const [currencies, setCurrencies] = useState([]);
  const [resetComponent, setResetComponent] = useState(false);

  const { reportOptions, userType } = useSelector((state) => ({
    reportOptions: getReportTypes(state),
    userType: getSessionInfo(state).userType,
  }));

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { getApiCAll, cancellCall } = useApi();

  useEffect(() => {
    Promise.all([dispatch(reportType()), getApiCAll(`/currency`)]).then(
      (response) => setCurrencies(response[1].data.data)
    );
    return () => cancellCall();
  }, []);

  useEffect(() => {
    if (userType === "CSA" && reportOptions.length > 0) setReport("BILLS");
  }, [reportOptions]);

  const handlerChange = (e) => {
    setFilters([]);
    setReport(e.target.value);
  };

  const getDefaultFilters = () => {
    const nameRef = "provider.institution.companyName";

    var defaultFilters = filters.map(({ property, value, ...rest }) => ({
      property,
      value: property === nameRef ? encodeURIComponent(value) : value,
      ...rest,
    }));

    switch (report) {
      case "PROVIDERS":
      case "CUSTOMERS":
        break;
    }
    return defaultFilters;
  };

  const getReport = async () => {
    if (!report) return;

    try {
      setModal({
        show: true,
        content: loadingHtml(t("report.filters.loading")),
        onClose: undefined,
      });

      const defaultFilters = getDefaultFilters();

      await dispatch(
        getReportData(
          report,
          userType,
          0,
          10,
          defaultFilters,
          report === "PROVIDERS"
        )
      );
      props.reportFilters(defaultFilters);
      props.setReportType(report);
      props.showDetails();
    } catch (error) {
      console.error(error);
    }
  };

  const clearFilters = () => {
    setResetComponent(!resetComponent);
    setFilterValue({});
    setFilters([]);
  };

  return (
    <Fragment>
      <div className="header-providers">
        <div className="title">
          <img src={reporticon} className="iconList" />
          <p className="p-list">{t("report.filters.header")}</p>
        </div>
      </div>
      <div className="reports">
        <div className="filters">
          <div className="row align-items-end">
            <div className="col-lg-6">
              <Selector
                id="reportType"
                label={t("report.filters.type")}
                name="reportType"
                onChange={handlerChange}
                placeholder={`${t("report.filters.placeholder")}`}
                value={report}
              >
                {reportOptions.map((type) => (
                  <option key={type.key} value={type.key}>
                    {type.name}
                  </option>
                ))}
              </Selector>
            </div>
            <FiltersByReport
              key={resetComponent.toString()}
              reportType={report}
              currencies={currencies}
              updateFilters={setFilters}
              setFilterValue={setFilterValue}
              filterValue={filterValue}
              userType={userType}
            />
          </div>
        </div>
      </div>
      <div className="form-actions clearfix">
        <SecondaryButton
          id={`clear-btn`}
          className={`btnLimpiar`}
          onClick={clearFilters}
        >
          {t("general.buttons.clear")}
        </SecondaryButton>
        <SecondaryButton
          id={`accept-btn`}
          className={`btnAgregar`}
          onClick={getReport}
        >
          {t("general.buttons.accept")}
        </SecondaryButton>
      </div>
      <Modal show={modal.show} handleClose={modal.onClose}>
        {modal.content}
      </Modal>
    </Fragment>
  );
};

export default ReportsFilters;
